import { ReactNode } from 'react';
import { TooltipWrapper } from '../../adminComponents';
import { Button } from '../button/button';
import { Div, Icon } from '../../styles';
import { AIStarsIcon } from '../../assets';

type Props = {
  small?: boolean;
  w?: string;
  /**
   * Without it the button is the "coming soon" placeholder: it does nothing
   * and says so in a tooltip.
   */
  onClick?: () => void;
  /** Replaces "Improve with AI", e.g. while a run is in progress. */
  label?: ReactNode;
  /** The gradient fill always, not only on hover. */
  filled?: boolean;
};

export const ImproveWithAIButton = ({
  small = false,
  w,
  onClick,
  label = 'Improve with AI',
  filled = false,
}: Props) => {
  const button = (
    <Button
      $small={small}
      $w={w}
      $wSM={small ? '50px' : '100%'}
      $blue
      $blueGradient
      $selected={filled}
      onClick={onClick}
    >
      <Div $flex $center $gap="8px">
        <Icon>
          <AIStarsIcon />
        </Icon>
        {/* One line always: a longer label must not break the pill in two. */}
        {small ? (
          <Div $desktop style={{ whiteSpace: 'nowrap' }}>
            {label}
          </Div>
        ) : (
          <Div style={{ whiteSpace: 'nowrap' }}>{label}</Div>
        )}
      </Div>
    </Button>
  );

  return (
    <Div $flex $flexNone>
      {onClick ? (
        button
      ) : (
        <TooltipWrapper tooltip="Improve with AI feature is coming soon. This feature is not available yet.">
          {button}
        </TooltipWrapper>
      )}
    </Div>
  );
};
